import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/ClusterApi";
import store from "../../../../Frontends/Common/store";

export class ClusterService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editCluster", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editCluster");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getClusters", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getCluster", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createCluster", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteCluster", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editCluster", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
